var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7215 0.278416C13.3503 -0.0928066 12.7484 -0.0928049 12.3772 0.278418L7.00001 5.65562L1.62285 0.278418C1.25163 -0.0928049 0.649764 -0.0928066 0.278543 0.278416C-0.092677 0.649639 -0.0926766 1.25151 0.278544 1.62273L5.65571 6.99994L0.278415 12.3773C-0.0928049 12.7485 -0.0928052 13.3504 0.278415 13.7216C0.649635 14.0928 1.2515 14.0928 1.62272 13.7216L7.00001 8.34425L12.3773 13.7216C12.7485 14.0928 13.3504 14.0928 13.7216 13.7216C14.0928 13.3504 14.0928 12.7485 13.7216 12.3773L8.34432 6.99994L13.7215 1.62273C14.0927 1.25151 14.0927 0.649639 13.7215 0.278416Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2d52cc8162073ba28e8e456cc99ca000.svg";
export { ForwardRef as ReactComponent };